var map = {
	"./base_images": 5776,
	"./base_images.json": 5776,
	"./baseimg_complex_1.jpg": 5222,
	"./baseimg_complex_2.jpg": 1182,
	"./baseimg_complex_3.jpg": 7457,
	"./baseimg_medium_1.jpg": 9703,
	"./baseimg_medium_2.jpg": 5517,
	"./baseimg_medium_3.jpg": 1982,
	"./baseimg_medium_4.jpg": 2547,
	"./baseimg_medium_5.jpg": 4213,
	"./baseimg_medium_6.jpg": 5350,
	"./baseimg_medium_7.jpg": 9818,
	"./baseimg_medium_8.jpg": 2005,
	"./baseimg_simple_1.jpg": 8865,
	"./baseimg_simple_2.jpg": 2258,
	"./baseimg_simple_3.jpg": 3332,
	"./baseimg_simple_4.jpg": 4662,
	"./baseimg_simple_5.jpg": 595,
	"./baseimg_simple_6.jpg": 4322,
	"./baseimg_simple_7.jpg": 593,
	"./baseimg_simple_8.jpg": 8961,
	"./placeholder.svg": 7975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7203;